import React, {useEffect, useState} from "react";
import {Form, FormikProps} from "formik";
import Button from "../../Elements/Button";
import httpClient from "../../../services/httpClient";
import Loading from "../../Elements/Loading/Loading";
import useToastNotify from "../../../hook/useToastNotify";
import {ISelectOptionsItem} from "../../../contracts/select_options";
import InputSelect from "../../Elements/Form/InputSelect";
import {auxiliaryApi} from "../../../constans/apiUrls";
import Input from "../../Elements/Form/Input";
import {IAttributeData, IAttributeFormData} from "../../../contracts/data/attribute";


const InnerAddAttributeToVideoProductForm = (props: FormikProps<IAttributeFormData>) => {
    const {toastNotify} = useToastNotify()
    const [loading, setLoading] = useState<boolean>(true)
    const [optionsAttributes, setOptionsAttributes] = React.useState<Array<ISelectOptionsItem>>([])

    const handleFetchAttributes = async () => {
        await httpClient().get(auxiliaryApi.attributes)
            .then(response => {
                if (response.status === 200) {
                    const array_option: Array<ISelectOptionsItem> = []
                    response?.data?.map((item: IAttributeData, _: number) => {
                        array_option.unshift({value: item.id, label: item?.title})
                    })
                    setOptionsAttributes(array_option)
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if(props?.status?.formType === 'create'){
            handleFetchAttributes()
        }else{
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        if(props?.status?.hasOwnProperty('result')){
            toastNotify(props.status?.result?.status, props.status?.result?.message)
        }
    }, [props.status])

    return (
        <React.Fragment>
            {loading ? <Loading /> : <Form>
                <div className={"w-full min-h-[250px]"}>
                    {props?.status?.formType === 'create' && <InputSelect name={'attribute'} label={'ویژگی'}
                                                                          placeholder={'ویژگی...'}
                                                                          handleSetValue={(values: any) => props.setFieldValue('attribute', values)}
                                                                          options={optionsAttributes} isMultiple={false} error={props?.errors?.attribute}
                                                                          meta={props.getFieldMeta('attribute')} isRequired={true} isSearchable={true}
                                                                          defaultValue={optionsAttributes.find((item, _) => item.value === props.values?.attribute)}
                    />}
                    <Input name={"content"} as={'textarea'} label={"مقدار ویژگی"} placeholder={"مقدار ویژگی..."} isRequired
                           meta={props.getFieldMeta('content')} defaultValue={props.values?.content}/>
                </div>
                <div className={"text-right"}>
                    <Button title={props?.status?.formType === 'create' ? "افزودن ویژگی" : "ویرایش ویژگی"} isLoading={props.isSubmitting}/>
                </div>
            </Form>}
        </React.Fragment>
    )
}

export default InnerAddAttributeToVideoProductForm